import React, { useEffect } from 'react';
import { Container } from 'reactstrap';
import FundsTable from '../FundsTable';
import useSyndicationAccess from '../common/useSyndicationAccess';

const LiveFunds = () => {
  const { hasLoadedPortfolio, isError, isUkPerson } = useSyndicationAccess();

  useEffect(() => {
    if (hasLoadedPortfolio && isUkPerson) {
      window.location.replace('/');
    }
  }, [hasLoadedPortfolio, isUkPerson]);

  if (!hasLoadedPortfolio || isError || isUkPerson) {
    return null;
  }

  return (
    <Container className="dashboard">
      <FundsTable />
    </Container>
  );
};

export default LiveFunds;
